export default () => ({
  statistic: {
    '& span:first-child': {
      color: '#7B8B99',
    },

    '& span:last-child': {
      color: '#27282A',
    },
  },

  fullWidth: {},

  summary: {
    fontSize: 13,
    width: 'calc(50% - 16px)',

    '&$fullWidth': {
      width: '100% !important',
    },

    '& > div': {
      padding: '20px 0',
      '&:not(:last-child)': {
        borderBottom: '1px solid #E1E6EB',
      },
      '&:nth-child(1)': {
        paddingTop: 0,
      },
    },
  },

  label: {},

  attributeList: {
    '& p': {
      padding: '0',
    },
    '& p span': {
      minWidth: 80,
      display: 'inline-block',
    },
    '& $label': {
      paddingBottom: 8,
    },
  },

  flag: {
    width: 22,
    height: 12,
    marginRight: 8,
    borderRadius: 3,
    boxShadow: '0px 1px 2px 0px rgba(0, 0, 0, 0.15)',
    overflow: 'hidden',
    '& img': {
      minHeight: '100%',
      minWidth: '100%',
      height: '100%',
    },
  },
});
